import { Subscription } from 'rxjs';
import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from '.';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `
  <div class="topo-selected-assets" align="left">
    <table
      style="font-size:14px;font-family:Verdana,Geneva,Tahoma,sans-serif;font-weight:400;color:#000000;border-collapse:collapse;"
      width="800px" border-spacing="2px" align="left" border="1px double #000000" cellpadding="0" cellspacing="0">
      <tr>
        <td style="padding:0.4em; font-weight: 700;">Asset Name</td>
        <td style="padding:0.4em; font-weight: 700;">Distance From Alert</td>
      </tr>
      <tr>
        <td style="padding:0.4em;">
          My Preview Asset
        </td>
        <td style="padding:0.4em;text-align:right;">
          5.00 mi
        </td>
     </tr>
    </table>
  </div>`;
const settingsControlTemplate = ``;

export class SelectedAssetsListControl extends DesignControl {
  editTextControl: HTMLElement;
  settingsControl: SettingsWrapperControl;
  saveEdit$: Subscription;
  cancelEdit$: Subscription;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.SelectedAssetsList;
    this.settingsControl = templateControlService.settingsWrapperControl;
  }

  public edit(): void {
    const textValue = this.controlElement.innerHTML;

    this.saveEdit$ = this.templateControlService.richTextUpdates$.subscribe(value => {
      this.controlElement.innerHTML = value;
      this.settingsControl.hide();

      this.saveEdit$.unsubscribe();
      this.cancelEdit$.unsubscribe();
    });

    this.cancelEdit$ = this.templateControlService.richTextCancel$.subscribe(() => {
      this.settingsControl.hide();

      this.saveEdit$.unsubscribe();
      this.cancelEdit$.unsubscribe();
    });

    this.templateControlService.editRichText(textValue);
  }

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}
}
